module.exports = __webpack_public_path__ + "media/src/ui/icons/WMV-59d63fceab1f7af40802c6d19915bdcb.svg";